var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipHighProtein({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM19.41 17L19.19 17.14C17.17 18.55 15.05 19.27 12.89 19.29H12.83C11.7 19.29 10.32 18.8 8.97 18.32C8.08 18.01 7.24 17.71 6.52 17.56C5.5 17.36 5.03 16.85 4.82 16.45C4.53 15.93 4.53 15.27 4.79 14.61C6.38 10.62 8.44 7.42 9.26 6.23C9.65 5.64 10.26 5.25 10.97 5.12L13.21 4.74C13.61 4.67 14.02 4.76 14.35 5C14.69 5.24 14.92 5.6 14.98 6.02L15.15 7.19C15.22 7.61 15.07 8.04 14.76 8.33C14.44 8.62 14 8.74 13.58 8.64L12.33 8.36L11.39 12C11.72 11.8 12.07 11.64 12.43 11.54C13.6 11.23 14.93 11.49 16.13 12.25C17.21 11.36 18.85 11.41 18.93 11.41L19.41 11.43V17Z",
    fill: "#364153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 15.47C15.53 16.49 13.86 16.46 12.96 16.12C12.71 16.02 12.42 16.14 12.32 16.4C12.22 16.66 12.35 16.95 12.6 17.05C13.09 17.24 13.66 17.34 14.23 17.34C15.31 17.34 16.42 16.96 17.08 16.06C17.25 15.84 17.2 15.53 16.97 15.36C16.75 15.2 16.44 15.25 16.27 15.47Z",
    fill: "#364153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipHighProtein);
export default __webpack_public_path__ + "static/media/ic-chip-high-protein.5957edbf0b69274e82dd68ef7c2dbec2.svg";
export { ForwardRef as ReactComponent };